import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, Figure, Row, Col } from "react-bootstrap";
import { Formik, Form } from "formik";
import { IoMdOpen } from "react-icons/io";
import { MdClose, MdCheck } from "react-icons/md";

const FileUploader = ({data, setFieldValue}) => {
  let [showReplace, setShowReplace] = React.useState(data.document_name != null)
  return (
    <>
      <FormGroup controlId="formFile" className="mb-3">
        {
          showReplace == true && (<>
            <label>Uploaded:</label>
            <div>{data.document_name}</div>
            <a  onClick={() => {
              setShowReplace(false);
            }}><i className={'fa fa-edit'} /> Replace</a>
          </>)
        }
        {
          showReplace == false && (
            <>
              <FormControl
                type="file"
                onChange={(e) =>
                  setFieldValue(
                    "document",
                    e.target.files[0]
                  )
                }
              />
              { data.document_name &&
                <a onClick={() => {
                  setShowReplace(true);
                }}><i className={'fa fa-times'} /> Cancel
                </a>
              }
            </>
          )
        }
      </FormGroup>
    </>
  );
}

export default FileUploader;
